<template>
  <div>
    <UiPageHeader
      title="My Account"
      breadcrumb="accounts / my-account"
      @toggle-nav="toggleNav"
    >
      <template #actions>
        <UiButton variant="primary" :left-icon="Save">Edit Account</UiButton>
      </template>
    </UiPageHeader>

    <UiCard>
      <template #header>
        <h2 class="text-sm font-semibold text-text">Profile</h2>
      </template>

      <UiEmpty
        :icon="User"
        title="Account Details Coming Soon"
        hint="This section will display your account information and settings."
      />

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 pt-0">
        <div>
          <label class="block text-[12px] font-medium text-text-2 mb-1.5">Full Name</label>
          <UiInput :model-value="''" placeholder="--" :left-icon="User" disabled />
        </div>
        <div>
          <label class="block text-[12px] font-medium text-text-2 mb-1.5">Email Address</label>
          <UiInput :model-value="''" placeholder="--" :left-icon="Mail" disabled />
        </div>
        <div>
          <label class="block text-[12px] font-medium text-text-2 mb-1.5">Role</label>
          <UiInput :model-value="''" placeholder="--" :left-icon="Shield" disabled />
        </div>
        <div>
          <label class="block text-[12px] font-medium text-text-2 mb-1.5">Contact Number</label>
          <UiInput :model-value="''" placeholder="--" :left-icon="KeyRound" disabled />
        </div>
      </div>
    </UiCard>
  </div>
</template>

<script>
import UiPageHeader from "@/components/ui/UiPageHeader.vue";
import UiCard from "@/components/ui/UiCard.vue";
import UiButton from "@/components/ui/UiButton.vue";
import UiInput from "@/components/ui/UiInput.vue";
import UiEmpty from "@/components/ui/UiEmpty.vue";
import { User, Mail, Shield, KeyRound, Save, Loader2 } from "lucide-vue-next";

export default {
  components: {
    UiPageHeader,
    UiCard,
    UiButton,
    UiInput,
    UiEmpty,
  },
  props: {
    toggleNav: { type: Function, default: () => {} },
  },
  data() {
    return {
      // Lucide icon symbols exposed to template scope
      User,
      Mail,
      Shield,
      KeyRound,
      Save,
      Loader2,
    };
  },
};
</script>

<style scoped>
/* All styling is now handled by Tailwind CSS utility classes */
</style>
